<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: left;">Christopher Lake is an educator of 28 years and spent his formative years teaching English and History. He found an early passion for fiction in college, then enjoyed teaching middle and high school literature in public schools. His inspiration to write formed from the many impactful books that helped shape his adult life. In 2018, Chris decided to write on a regular basis to express his passion for literature.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?46a00e27